module.exports = __webpack_public_path__ + "static/img/advantages-3.b5fdb21c.png";